import CONFIGS from "../config/config";
import Api from "../helpers/Api";

const { BASE_URL } = CONFIGS;
let api = new Api(BASE_URL);
export default api;
